import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const workHistory = () => ({
    "collection-agency" : {
        header : "Work history",
        text : ["Provide work history details for the past 3 years for each company director, partner, and officer. Include job title, company, dates, and a brief description of the role.  If you don't provide this information in your application, it will delay your agency's approval for a licence."],
        headerRenewal : "Work history",
        textRenewal : [
            'Review work history details for the past 3 years for each company director, partner, and officer.'
        ],
        navigation : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION,
            nextRenewal : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION
        }
    }, 
    "debt-management-agency" : {
        header : "Work history",
        text : [
            "Provide work history details for the past 3 years for each company director, partner, and officer. Include job title, company, dates, and a brief description of the role.  If you don't provide this information in your application, it will delay your agency's approval for a licence."],
        headerRenewal : "Work history",
        textRenewal : [
            'Review work history details for the past 3 years for each company director, partner, and officer.'
        ],
        navigation : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION,
            nextRenewal : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION
        }
    }
})

const workHistoryDetailsSlice = createSlice({
    name : 'workHistory',
    initialState : workHistory(),
    reducers : {

    }
})

export default workHistoryDetailsSlice.reducer
